import React from "react";
import { Link } from "react-router-dom";
import { MASCOT_FULL, MASCOT_IMG, MASCOT_NAME, MASCOT_STANDING } from "./mascotScript";

export const openMascotChat = () => window.dispatchEvent(new Event("open-mascot-chat"));

export const MascotAvatar = ({ size = "w-9 h-9", className = "" }) => (
  <img src={MASCOT_IMG} alt={MASCOT_NAME} className={`${size} rounded-full object-cover bg-sky-100 ring-2 ring-white shadow ${className}`} />
);

export const MascotHero = ({ src = MASCOT_FULL }) => (
  <div className="flex justify-center pt-1 pb-2" data-testid="mascot-fullbody">
    <img src={src} alt={MASCOT_NAME} className="h-44 w-auto rounded-2xl mascot-pop" />
  </div>
);

export const MascotStanding = () => (
  <button type="button" onClick={openMascotChat} data-testid="mascot-standing" aria-label={`Conversar com ${MASCOT_NAME}`}
    className="group absolute z-10 -bottom-10 -right-2 md:-right-10 lg:-right-16 flex items-end">
    <span className="hidden sm:block mb-[62%] -mr-3 px-3 py-2 rounded-2xl rounded-br-md bg-white border border-slate-200 shadow-xl text-[12px] font-black text-[#0f172a] whitespace-nowrap mascot-pop group-hover:text-[#7c3aed] transition-colors">
      Oi! Sou o Maurilho. Bora conversar?
    </span>
    <img src={MASCOT_STANDING} alt={MASCOT_NAME} className="h-56 sm:h-72 lg:h-[26rem] w-auto drop-shadow-[0_20px_25px_rgba(15,23,42,0.35)] mascot-pop group-hover:-translate-y-1 transition-transform duration-300" />
  </button>
);

export const MascotLauncher = ({ onClick, testid, className = "" }) => (
  <button type="button" onClick={onClick} data-testid={testid} aria-label={`Conversar com ${MASCOT_NAME}`}
    className={`group fixed z-40 flex items-end ${className}`}>
    <span className="mb-14 -mr-2 px-3 py-2 rounded-2xl rounded-br-md bg-white border border-slate-200 shadow-xl text-[12px] font-black text-[#0f172a] whitespace-nowrap mascot-pop group-hover:text-[#7c3aed] transition-colors" data-testid={`${testid}-bubble`}>
      No que posso te ajudar hoje?
    </span>
    <img src={MASCOT_STANDING} alt={MASCOT_NAME} className="h-28 md:h-32 w-auto drop-shadow-[0_10px_12px_rgba(15,23,42,0.35)] mascot-pop group-hover:-translate-y-1 transition-transform duration-300" />
  </button>
);

export const Bubble = ({ from, children, testid }) => (
  <div className={`flex gap-2 items-end ${from === "user" ? "justify-end" : ""} mascot-msg-in`} data-testid={testid}>
    {from === "bot" && <MascotAvatar size="w-7 h-7" />}
    <div className={`max-w-[80%] px-3 py-2 text-[13px] leading-snug rounded-2xl ${from === "user" ? "bg-[#1e3a8a] text-white rounded-br-md" : "bg-white text-slate-800 border border-slate-200 rounded-bl-md shadow-sm"}`}>
      {children}
    </div>
  </div>
);

export const BotLink = ({ link }) => (
  <Link to={link.to} data-testid={`mascot-link-${link.to.replace(/\//g, "")}`} className="inline-block mt-1 font-black text-[#7c3aed] underline underline-offset-2">
    {link.label} →
  </Link>
);

export const MascotWelcome = () => (
  <button type="button" onClick={openMascotChat} data-testid="mascot-welcome"
    className="group mb-5 inline-flex items-center gap-3 pr-4 pl-1.5 py-1.5 rounded-full bg-white/90 backdrop-blur border border-slate-200 shadow-lg shadow-indigo-900/10 hover:shadow-xl transition-shadow mascot-pop">
    <MascotAvatar size="w-12 h-12" className="mascot-wave" />
    <span className="text-left leading-tight">
      <span className="block text-[13px] font-black text-[#0f172a]">Oi! Eu sou o Maurilho, da AMC</span>
      <span className="block text-[12px] text-slate-500 group-hover:text-[#7c3aed] transition-colors">Bem-vindo(a)! Tem dúvida? Fala comigo →</span>
    </span>
  </button>
);
